// import React, { useState, useEffect, useCallback } from "react";
// import "./EmailPassword.css";
// import { useDispatch } from "react-redux";
// import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
// import Loader from "../../Loader";
// import { useNavigate, useParams } from "react-router-dom";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import { signUp } from "../../../api/auth";

// // debounce utility
// function debounce(fn, delay) {
//   let timer;
//   return function (...args) {
//     clearTimeout(timer);
//     timer = setTimeout(() => fn(...args), delay);
//   };
// }

// function EmailPassword() {
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [referralCode, setReferralCode] = useState("");
//   const [isReferralCodeValid, setIsReferralCodeValid] = useState(false);
//   const [isReferralFromUrl, setIsReferralFromUrl] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [passwordError, setPasswordError] = useState("");
//   const [confirmPasswordError, setConfirmPasswordError] = useState("");
//   const [referralCodeError, setReferralCodeError] = useState("");
//   const [isPasswordValid, setIsPasswordValid] = useState(false);
//   const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);
  
//   const [isCheckingReferral, setIsCheckingReferral] = useState(false);
  
//   const [agreed, setAgreed] = useState(false);

//   const dispatch = useDispatch();
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams(); 
//   const referralFromUrl = searchParams.get("referralcode"); 
  

//   // Password validation
//   const validatePassword = (password) => {
//     const minLength = 8;
//     const hasUpperCase = /[A-Z]/.test(password);
//     const hasLowerCase = /[a-z]/.test(password);
//     const hasNumbers = /\d/.test(password);
//     const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

//     if (password.length < minLength) {
//       return "Password must be at least 8 characters long";
//     }
//     if (!hasUpperCase) {
//       return "Password must contain at least one uppercase letter";
//     }
//     if (!hasLowerCase) {
//       return "Password must contain at least one lowercase letter";
//     }
//     if (!hasNumbers) {
//       return "Password must contain at least one number";
//     }
//     if (!hasSpecialChar) {
//       return "Password must contain at least one special character";
//     }
//     return null;
//   };

//   // Confirm password validation
//   const validateConfirmPassword = (confirmPassword, password) => {
//     if (confirmPassword !== password) {
//       return "Passwords do not match";
//     }
//     return null;
//   };

//   // Referral code validation (mock API call)
//   const checkReferralCode = async (code) => {
//     if (!code || code.length < 3) {
//       setReferralCodeError("Referral code must be at least 3 characters");
//       setIsReferralCodeValid(false);
//       return;
//     }

//     setIsCheckingReferral(true);
//     try {
//       // Mock API call - replace with actual API
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       // Mock validation logic
//       if (code.toLowerCase() === "invalid") {
//         setReferralCodeError("Invalid referral code");
//         setIsReferralCodeValid(false);
//       } else {
//         setReferralCodeError("Referral code is valid!");
//         setIsReferralCodeValid(true);
//       }
//     } catch (error) {
//       setReferralCodeError("Error validating referral code");
//       setIsReferralCodeValid(false);
//     } finally {
//       setIsCheckingReferral(false);
//     }
//   };

//   // debounce the referral code check
//   const debouncedCheckReferralCode = useCallback(debounce(checkReferralCode, 500), []);

//   // Password validation effect
//   useEffect(() => {
//     if (password) {
//       const error = validatePassword(password);
//       setPasswordError(error || "");
//       setIsPasswordValid(!error);
//     } else {
//       setPasswordError("");
//       setIsPasswordValid(false);
//     }
//   }, [password]);

//   // Confirm password validation effect
//   useEffect(() => {
//     if (confirmPassword) {
//       const error = validateConfirmPassword(confirmPassword, password);
//       setConfirmPasswordError(error || "");
//       setIsConfirmPasswordValid(!error);
//     } else {
//       setConfirmPasswordError("");
//       setIsConfirmPasswordValid(false);
//     }
//   }, [confirmPassword, password]);

//   // Referral code validation effect
//   useEffect(() => {
//     if (referralCode) {
//       debouncedCheckReferralCode(referralCode);
//     } else {
//       setReferralCodeError("");
//       setIsReferralCodeValid(false);
//     }
//   }, [referralCode, debouncedCheckReferralCode]);

//   const handlePrivacyPolicyClick = () => {
//     navigate("/privacy-policy");
//   };

//   const handleTermsOfUseClick = () => {
//     navigate("/terms-of-use");
//   };

//   const handleSignUp = async () => {
//     if (!password) {
//       console.error("Password is required");
//       return;
//     }
  
//     setIsLoading(true);
//     try {
//       const payload = {
//         email: localStorage.getItem("email"),
//         password: password,
//         refreeAffiliateCode: localStorage.getItem("referralCode") || null,
//       };
  
//       const response = await signUp(payload);
//       console.log("SignUp API Response:", response);
//       if (response?.success || response?.statusCode === 200) {
//         // Navigate to next step
//         localStorage.setItem("email", payload.email);
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem("refreshToken", response.data.refreshToken);
//         dispatch(setActiveComponent("signUpSuccessfull"));
//       } else {
//         console.error("Signup failed:", response?.message);
//       }
//     } catch (error) {
//       console.error("Error signing up:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };  

//   const isFormValid = isPasswordValid && isConfirmPasswordValid && agreed;

//   return (
//     <div className="EmailPassword">
//       <div className="emailPasswordContainer">
//         <div className="generalInputContainer">
//           <label htmlFor="passwordInput" className="labelText">
//             Password
//           </label>
//           <div className="inputContainerWrapper">
//             <input
//               id="passwordInput"
//               className="input"
//               type={showPassword ? "text" : "password"}
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />
//             <button
//               type="button"
//               className="eyeIcon"
//               onClick={() => setShowPassword(!showPassword)}
//             >
//               {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//             </button>
//             {passwordError && <span className="errorTooltip">{passwordError}</span>}
//           </div>
//         </div>

//         <div className="generalInputContainer">
//           <label htmlFor="confirmPasswordInput" className="labelText">
//             Confirm Password
//           </label>
//           <div className="inputContainerWrapper">
//             <input
//               id="confirmPasswordInput"
//               className="input"
//               type={showConfirmPassword ? "text" : "password"}
//               placeholder="Confirm your password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//             />
//             <button
//               type="button"
//               className="eyeIcon"
//               onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//             >
//               {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//             </button>
//             {confirmPasswordError && <span className="errorTooltip">{confirmPasswordError}</span>}
//           </div>
//         </div>

//         <div className="generalInputContainer">
//           <label htmlFor="referralCodeInput" className="labelText">
//             Referral Code (Optional)
//           </label>
//           <div className="inputContainerWrapper">
//             <input
//               id="referralCodeInput"
//               className="input"
//               type="text"
//               placeholder="Enter referral code"
//               value={referralCode}
//               onChange={(e) => setReferralCode(e.target.value)}
//             />
//             {isCheckingReferral && <Loader />}
//             {referralCodeError && <span className="errorTooltip">{referralCodeError}</span>}
//           </div>
//         </div>

//         <div className="checkboxContainer">
//           <input
//             type="checkbox"
//             checked={agreed}
//             onChange={() => setAgreed(!agreed)}
//           />
//           <label className="checkboxLabel">
//             By signing up you agree to the{" "}
//             <span className="irregularText" onClick={handleTermsOfUseClick}>
//               terms of use
//             </span>{" "}
//             and{" "}
//             <span className="irregularText" onClick={handlePrivacyPolicyClick}>
//               privacy policy
//             </span>
//           </label>
//         </div>

//         <button
//           className="btnContainer"
//           disabled={!isFormValid || isLoading}
//           onClick={handleSignUp}
//         >
//           {isLoading ? <Loader /> : <span className="btnText">Next</span>}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default EmailPassword;



/*------------------------------------------Latest Code with Referral Code And new Signup Api flow----------------------------------------------------*/

import React, { useState, useEffect } from "react";
import "./EmailPassword.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import Loader from "../../Loader";
import { useNavigate, useSearchParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { signUp, verifyReferralCode } from "../../../api/auth";
import { setAuthTokens } from "../../../api/index";

function EmailPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [isReferralFromUrl, setIsReferralFromUrl] = useState(false);
  const [isReferralValid, setIsReferralValid] = useState(false);
  const [isCheckingReferral, setIsCheckingReferral] = useState(false);
  const [referralCodeError, setReferralCodeError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [agreed, setAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Prefill referral code from URL if exists and validate it
  useEffect(() => {
    const code = searchParams.get("referralcode");
    if (!code) return;
    let isMounted = true;
    const verifyFromUrl = async () => {
      try {
        setIsCheckingReferral(true);
        const response = await verifyReferralCode(code);
        if (!isMounted) return;
        if (response?.success || response?.statusCode === 200) {
          setReferralCode(code);
          setIsReferralFromUrl(true);
          setIsReferralValid(true);
          setReferralCodeError("");
          // persist for later steps
          localStorage.setItem("refreeAffiliateCode", code);
          localStorage.setItem("referralCode", code);
        } else {
          setReferralCode(code);
          setIsReferralFromUrl(false);
          setIsReferralValid(false);
          setReferralCodeError("Invalid referral code. Please enter a correct code or sign up without one.");
        }
      } catch (err) {
        if (!isMounted) return;
        setReferralCode(code);
        setIsReferralFromUrl(false);
        setIsReferralValid(false);
        setReferralCodeError("Invalid referral code. Please enter a correct code or sign up without one.");
      } finally {
        if (isMounted) setIsCheckingReferral(false);
      }
    };
    verifyFromUrl();
    return () => {
      isMounted = false;
    };
  }, [searchParams]);

  // If no URL code, honor previously validated and locked referral from storage
  useEffect(() => {
    const urlCode = searchParams.get("referralcode");
    if (urlCode) return; // handled by the effect above
    const locked = localStorage.getItem("isReferralLocked") === "true";
    const stored = localStorage.getItem("refreeAffiliateCode") || localStorage.getItem("referralCode");
    if (locked && stored) {
      setReferralCode(stored);
      setIsReferralFromUrl(true);
      setIsReferralValid(true);
      setReferralCodeError("");
    }
  }, [searchParams]);

  // Password validation
  useEffect(() => {
    if (!password) {
      setPasswordError("");
      return;
    }
    if (password.length < 8) setPasswordError("Password must be at least 8 characters");
    else if (!/[A-Z]/.test(password)) setPasswordError("Password must contain an uppercase letter");
    else if (!/[a-z]/.test(password)) setPasswordError("Password must contain a lowercase letter");
    else if (!/\d/.test(password)) setPasswordError("Password must contain a number");
    else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) setPasswordError("Password must contain a special character");
    else setPasswordError("");
  }, [password]);

  // Confirm password validation
  useEffect(() => {
    if (confirmPassword && confirmPassword !== password) setConfirmPasswordError("Passwords do not match");
    else setConfirmPasswordError("");
  }, [confirmPassword, password]);

  // Validate referral code on manual changes (debounced) when not locked from URL
  useEffect(() => {
    if (!referralCode) {
      setReferralCodeError("");
      setIsReferralValid(false);
      return;
    }
    if (isReferralFromUrl) return; // URL codes are already validated/locked

    const timeoutId = setTimeout(async () => {
      try {
        setIsCheckingReferral(true);
        const response = await verifyReferralCode(referralCode.trim());
        if (response?.success || response?.statusCode === 200) {
          setReferralCodeError("");
          setIsReferralValid(true);
          localStorage.setItem("refreeAffiliateCode", referralCode.trim());
          localStorage.setItem("referralCode", referralCode.trim());
        } else {
          setReferralCodeError("Invalid referral code. Please enter a correct code or sign up without one.");
          setIsReferralValid(false);
        }
      } catch (err) {
        setReferralCodeError("Invalid referral code. Please enter a correct code or sign up without one.");
        setIsReferralValid(false);
      } finally {
        setIsCheckingReferral(false);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [referralCode, isReferralFromUrl]);

  const handleSignUp = async () => {
    if (passwordError || confirmPasswordError) return;
    
    // Prevent submission if referral code is invalid
    if (referralCode && !isReferralValid) {
      setReferralCodeError("Invalid referral code. Please enter a correct code or sign up without one.");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        email: localStorage.getItem("email"),
        password,
        refreeAffiliateCode: isReferralValid ? referralCode : null,
      };

      const response = await signUp(payload);
      if (response?.success || response?.statusCode === 200) {
        // Use the centralized setAuthTokens function for consistent token management
        setAuthTokens(response.data);
        if (isReferralValid && referralCode) {
          localStorage.setItem("referralCode", referralCode);
          localStorage.setItem("refreeAffiliateCode", referralCode);
        }
        localStorage.setItem("userId", response.data.userDetails.userId);
        dispatch(setActiveComponent("signUpSuccessfull"));
      } else {
        console.error("Signup failed:", response?.message);
      }
    } catch (error) {
      console.error("Error signing up:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = password && confirmPassword && !passwordError && !confirmPasswordError && agreed && (!referralCode || isReferralValid);

  return (
    <div className="EmailPassword">
      <div className="emailPasswordContainer">

        {/* Password */}
        <div className="generalInputContainer">
          <label className="labelText">Password</label>
          <div className="inputContainerWrapper">
            <input
              className="input"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="button" className="eyeIcon" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </button>
            {passwordError && <span className="errorTooltip">{passwordError}</span>}
          </div>
        </div>

        {/* Confirm Password */}
        <div className="generalInputContainer">
          <label className="labelText">Confirm Password</label>
          <div className="inputContainerWrapper">
            <input
              className="input"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button type="button" className="eyeIcon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </button>
            {confirmPasswordError && <span className="errorTooltip">{confirmPasswordError}</span>}
          </div>
        </div>

        {/* Referral Code */}
        <div className="generalInputContainer">
          <label className="labelText">Referral Code (Optional)</label>
          <div className="inputContainerWrapper">
            <input
              className="input"
              type="text"
              placeholder="Enter referral code"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              disabled={isReferralFromUrl && isReferralValid}
            />
            {isCheckingReferral && <Loader />}
            {referralCodeError && <span className="errorTooltip">{referralCodeError}</span>}
          </div>
        </div>

        {/* Agreement */}
        <div className="checkboxContainer">
          <input type="checkbox" checked={agreed} onChange={() => setAgreed(!agreed)} />
          <label className="checkboxLabel">
            By signing up you agree to the terms of use and privacy policy
          </label>
        </div>

        {/* Submit */}
        <button className="btnContainer" disabled={!isFormValid || isLoading} onClick={handleSignUp}>
          {isLoading ? <Loader /> : <span className="btnText">Next</span>}
        </button>
      </div>
    </div>
  );
}

export default EmailPassword;








